module.exports = __webpack_public_path__ + "img/logo.6085e55e.png";